export function showToast(message, options = {}) {
  if (typeof window === "undefined" || !message) return;
  window.dispatchEvent(
    new CustomEvent("app:toast", {
      detail: {
        message,
        type: options.type || "info",
        duration: options.duration || 3200,
      },
    })
  );
}
